module.exports = "/_next/static/images/DeliveryWarehousesETL@2x-a9df711ef64be461be8e60c378e58df7.png";